if (!window.__productCardSwatchListenerAdded) {
  window.__productCardSwatchListenerAdded = true;

  function buildVariantUrl(productUrl, variantId) {
    // productUrl may already carry a query string (e.g. tracking params added
    // by a recommendations app), so use the URL API instead of blindly
    // appending with "?", which would produce an invalid double "?".
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('variant', variantId);
    return url.pathname + url.search + url.hash;
  }

  function updateSizeAvailability(card, group, selectedValue) {
    const optionsWrapper = card.querySelector('.product-card__variant-options');
    const sizesGroup = card.querySelector('.product-card__sizes');
    if (!optionsWrapper || !sizesGroup) return;

    const dataScript = optionsWrapper.querySelector('script[data-product-card-variants]');
    if (!dataScript) return;

    let variants;
    try {
      variants = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    const colorPosition = parseInt(group.getAttribute('data-option-position'), 10);
    const sizePosition = parseInt(sizesGroup.getAttribute('data-option-position'), 10);
    if (!colorPosition || !sizePosition) return;

    const colorIndex = colorPosition - 1;
    const sizeIndex = sizePosition - 1;

    const linkOverlay = card.querySelector('.product-card__link-overlay');
    const titleLink = card.querySelector('.product-card__title a');
    const productUrl = (linkOverlay && linkOverlay.getAttribute('href'))
      || (titleLink && titleLink.getAttribute('href'))
      || null;

    sizesGroup.querySelectorAll('.product-card__size-value').forEach((sizeEl) => {
      const sizeValue = sizeEl.getAttribute('data-value');
      const matchingVariant = variants.find((variant) => {
        return (
          variant.options[colorIndex] === selectedValue &&
          variant.options[sizeIndex] === sizeValue
        );
      });

      const isAvailable = !!(matchingVariant && matchingVariant.available);
      sizeEl.classList.toggle('product-card__size-value--disabled', !isAvailable);

      if (isAvailable && productUrl) {
        sizeEl.setAttribute('href', buildVariantUrl(productUrl, matchingVariant.id));
        sizeEl.removeAttribute('aria-disabled');
        sizeEl.removeAttribute('tabindex');
      } else {
        // Disabled/crossed-out sizes should not navigate anywhere on click.
        sizeEl.removeAttribute('href');
        sizeEl.setAttribute('aria-disabled', 'true');
        sizeEl.setAttribute('tabindex', '-1');
      }
    });
  }

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.product-card__swatch');
    if (!swatch) return;

    const group = swatch.closest('.product-card__swatches');
    const card = swatch.closest('.product-card');
    if (!group || !card) return;

    event.preventDefault();

    group
      .querySelectorAll('.product-card__swatch')
      .forEach((el) => {
        el.classList.remove('product-card__swatch--selected');
        el.setAttribute('aria-pressed', 'false');
      });
    swatch.classList.add('product-card__swatch--selected');
    swatch.setAttribute('aria-pressed', 'true');

    const selectedValue = swatch.getAttribute('data-value');
    if (selectedValue) {
      updateSizeAvailability(card, group, selectedValue);
    }

    const newSrc = swatch.getAttribute('data-variant-image');
    if (!newSrc) return;

    const img = card.querySelector('.product-card__media img.media--first');
    if (!img) return;

    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = newSrc;

    const newAlt = swatch.getAttribute('data-variant-alt');
    if (newAlt) img.alt = newAlt;
  });
}
